module.exports = __webpack_public_path__ + "static/media/option_c.64b17983.png";